import { styled, Box, Typography } from "@mui/material"
import { Button } from "components"
import { IoIosCheckmarkCircleOutline } from "react-icons/io"

interface Props {
  title?: string
  handleClose: () => void
}

export const BoxCompleted = styled(Box)(({ theme }) => ({
  textAlign: "center",
  marginTop: "2rem",
}))

export const Message = styled(Typography)(({ theme }) => ({
  fontFamily: "Inter",
  fontWeight: 500,
  fontSize: "1rem",
  lineHeight: "1rem",
  color: "#353535",
  margin: "1rem 0 2.5rem",
}))

export const Btn = styled(Button)(({ theme }) => ({
  padding: "1rem 2.6rem",
}))

export const Success = (props: Props) => {
  const { handleClose, title } = props

  return (
    <BoxCompleted>
      <Box>
        <IoIosCheckmarkCircleOutline size="4rem" color="#618619" />
        <Message variant="subtitle1">{title}</Message>
      </Box>

      <Btn type="submit" onClick={handleClose} variant="contained">
        Fechar
      </Btn>
    </BoxCompleted>
  )
}
